import './SocialUpdatePhotoPreview.scss';

import editIcon from 'assets/svgs/edit.svg';
import { useGetPetProfile } from 'hooks/useGetPetProfile';
import { observer } from 'mobx-react-lite';
import { IconImage } from 'petdna-lib-uicomponents/components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ISocialUpdatePhotoPreviewProps {
  img: string;
  onCropImage: () => void;
}

const SocialUpdatePhotoPreview: FC<ISocialUpdatePhotoPreviewProps> = observer(({
  img,
  onCropImage,
}) => {
  const { t } = useTranslation();
  const { testsStore } = useGetPetProfile();
  const { petProfile } = testsStore;

  return (
    <div className="social-update-photo-preview">
      <div className="social-update-photo-preview__image-wrapper">
        <img src={img} alt="preview" />
        <button type="button" className="btn social-update-photo-preview__edit-btn" onClick={onCropImage}>
          <IconImage className="edit-icon" src={editIcon} color="#262626" />
          {t('socialSharingModal.cropImage')}
        </button>
      </div>
      <div className="social-update-photo-preview__text">
        <div className="social-update-photo-preview__title">{t('socialSharingModal.saveNewProfilePhoto')}</div>
        <div className="social-update-photo-preview__desc">{t('socialSharingModal.wouldYouLikeToSaveThisPhoto', { petName: petProfile?.name })}</div>
      </div>
    </div>
  );
});

export default SocialUpdatePhotoPreview;
